export function isGrade2(value: unknown): boolean {
  if (typeof value === 'number' && Number.isFinite(value)) return value === 2;
  const normalized = String(value ?? '').trim().toLowerCase();
  return normalized === '2' || normalized === 'grade 2' || normalized === 'g2';
}
